var map = {
	"./home.png": "205a",
	"./home_focus.png": "2540",
	"./local.png": "e8d8",
	"./local_focus.png": "5659",
	"./my.png": "3626",
	"./my_focus.png": "7f1c",
	"./search.png": "2922",
	"./search_focus.png": "09bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7725";